import React from 'react';
import {
	Page,
	Text,
	View,
	Document,
	StyleSheet,
	Font,
	Image,
} from '@react-pdf/renderer';

// Import and register Roboto font
import RobotoMonoRegular from 'src/fonts/RobotoMono-Regular.ttf';
import RobotoMonoItalic from 'src/fonts/RobotoMono-Italic.ttf';
import RobotoMonoBold from 'src/fonts/RobotoMono-Bold.ttf';
import RobotoMonoBoldItalic from 'src/fonts/RobotoMono-BoldItalic.ttf';

Font.register({
	family: 'RobotoMono',
	fonts: [
		{ src: RobotoMonoRegular, fontStyle: 'normal', fontWeight: 'normal' },
		{ src: RobotoMonoItalic, fontStyle: 'italic', fontWeight: 'normal' },
		{ src: RobotoMonoBold, fontStyle: 'normal', fontWeight: 'bold' },
		{ src: RobotoMonoBoldItalic, fontStyle: 'italic', fontWeight: 'bold' },
	],
});

// Create styles
const styles = StyleSheet.create({
	page: {
		flexDirection: 'row',
		padding: 30,
		paddingBottom: 40,
		fontFamily: 'RobotoMono',
		fontSize: 12,
		lineHeight: 1.2,
		//textAlign: 'justify',
	},
	title: {
		fontSize: 18,
		marginBottom: 12,
		lineHeight: 1.5,
	},
	preamble: {
		fontSize: 12,
		marginBottom: 8,
	},
	break: {
		marginBottom: 8,
		display: 'block',
	},
	blockquote: {
		margin: 10,
		paddingLeft: 20,
		fontStyle: 'italic',
	},
	bold: {
		fontWeight: 'bold',
	},
	italic: {
		fontStyle: 'italic',
	},
	underline: {
		textDecoration: 'underline',
	},
	table: {
		display: 'table',
		width: 'auto',
		borderStyle: 'solid',
		borderWidth: 1,
		borderRightWidth: 0,
		borderBottomWidth: 0,
	},
	row: {
		flexDirection: 'row',
	},
	header: {
		backgroundColor: '#eee',
		fontWeight: 'bold',
	},
	cell: {
		borderStyle: 'solid',
		borderBottomWidth: 1,
		borderRightWidth: 1,
		padding: 5,
		fontSize: 10,
		width: '14.28%', // 7 columns
	},
});

// Create Document Component
const WatchlistExportPdf = ({ content }) => {
	console.log(content);

	return (
		<Document>
			<Page
				size="A4"
				orientation="landscape"
				style={styles.page}
				renderAnnotationLayer={false}
				renderTextLayer={false}
			>
				<View>
					<View style={{ display: 'flex', flexDirection: 'row' }}>
						<Image
							src="/logo.png"
							style={{
								width: 100,
								height: 24,
								marginTop: 2,
								marginRight: 8,
							}}
						/>
						<Text style={styles.title}>Bevakningar</Text>
					</View>
					<View>
						<Text style={{ ...styles.preamble, ...styles.italic }}>
							Denna fil innehåller en lista över alla bevakningar
							ni skapat i systemet.
						</Text>
					</View>
					<View style={styles.table}>
						{/* Header Row */}
						<View style={[styles.row, styles.header]}>
							<Text style={styles.cell}>Namn</Text>
							<Text style={styles.cell}>Senast ändrad</Text>
							<Text style={styles.cell}>Beskrivning</Text>
							<Text style={styles.cell}>Avdelning</Text>
							<Text style={styles.cell}>Ansvarig</Text>
							<Text style={styles.cell}>Rutin</Text>
							<Text style={styles.cell}>Epostmottagare</Text>
						</View>

						{/* Data Rows */}
						{content.map((watchlistItem, index) => (
							<View style={styles.row} key={index}>
								<Text style={styles.cell}>
									{watchlistItem.name}
								</Text>
								<Text style={styles.cell}>
									{watchlistItem.lastUpdated}
								</Text>
								<Text style={styles.cell}>
									{watchlistItem.description}
								</Text>
								<Text style={styles.cell}>
									{watchlistItem.organization}
								</Text>
								<Text style={styles.cell}>
									{watchlistItem.responsible}
								</Text>
								<Text style={styles.cell}>
									{watchlistItem.routines}
								</Text>
								<Text style={styles.cell}>
									{watchlistItem.emails.join(', ')}
								</Text>
							</View>
						))}
					</View>
				</View>
			</Page>
		</Document>
	);
};

export default WatchlistExportPdf;
